import styled from 'styled-components';
import colors from 'styles/colors';
import fonts from 'styles/fonts';

export const CompareCTA = styled.p`
  font-family: ${fonts.primary.bold};
  font-size: 14px;
  line-height: 24px;
  color: ${colors.functional.black};
  margin-top: 24px;
  margin-bottom: 20px;
`;

export const CompareList = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CompareListItem = styled.li`
  display: flex;
`;
